module.exports = __webpack_public_path__ + "widget-devices-6c72c5f519b2fdca6f9fad7467403e57.png";